<template>
  <div class="components__gon-wrapper">
    <slot v-bind:gon="gon"></slot>
  </div>
</template>

<script lang="ts" setup>
  import { ref } from "vue";

  const gon = ref(JSON.parse(JSON.stringify((window as any).gon)));
</script>
